import { serverBus } from '@/main';
import Global from '@/scripts/Global'
import FolderApi from '@/scripts/api/folder.api'
import ChannelApi from '@/scripts/api/channel.api'
import SessionManager from '@/Manager/Session.manager'
import UserApi from '@/scripts/api/user.api';
import { CPUtils } from '@/scripts/Utils';
import { Logging } from '@/scripts/Logging';
import VueSignals from '@/scripts/VueSignals';
import ChannelNotification from '@/Manager/Notification/Channel.manager';
import { Channel } from '@/classes/Channel';

export default {
    name: 'CreateNewRootFolder',
    data (){
        return {
          channelFactory: SessionManager,
          folders: [],
          showModal: false,
          purpose:'',
          channel_name:'Channel name',
          mainSpinner: false,
          overlayType : Global.getGlobalSessionValue(VueSignals.OVERLAY_TYPE),
          nodes: [],
          selectedNodeId: '',
          newFolderName: '',
          newFolderId: '',
          folderCreationLoading: false,
          withChannel: false,
          createError:false,
          errorType:'',
          errorMessage:'',
          activeView: 'newFolder',
          rootFolderContent: [],
          endOfContent: false,
          skip: 0,
          choosedExistingFolderId: '',
          listSubFolderOfFolderId: '',
          parentId: '',
          subFolderSkip:0,
          subFolderContent: [],
          subFolder: false,
          isDevelop: Global.isDevelop() || Global.isTest(),
        }
      },
    updated(){
        if(this.activeView == 'existingFolder' && document.querySelector(".folder-list") != null){
          document.querySelector(".folder-list").addEventListener('scroll', this.HandleScroll)
        }
      },
    mounted() {
      this.mainSpinner = true
        if(document.querySelector('.active-input') != null){
          document.querySelector('.active-input').focus()
        }
        this.withChannel = this.$parent.data.withChannel
        this.showModal = true
        Global.globalValue(VueSignals.SHOW_MODAL, this.showModal)

        UserApi.getNodes().then(res => {
          if(res.data.length > 0){
            this.nodes = res.data
          }

          this.nodes.sort((a, b) => {
            if(b.node_type == 'cloud'){
                    return 1
            }else if(typeof b.last_online != 'undefined' &&
                    typeof a.last_online != 'undefined' &&
                    b.last_online > a.last_online ){
                  return 1
                }
              return -1

          })
          this.mainSpinner = false
        })

      serverBus.$on(VueSignals.OVERLAY_TYPE, (overlayType) => {
        this.overlayType = overlayType;
      })

      serverBus.$on(VueSignals.CLEAR_CREATE_FOLDER_ERROR, (overlayType) => {
        this.errorType = ''
        this.errorMessage = ''
        this.createError  = false
      })

      serverBus.$on(VueSignals.SHOW_MODAL, (showModal) => {
        this.showModal = showModal
      })

      this.FolderApiCall(this.skip)
    },
  methods: {
    closeModal(){
      this.showModal = false
    },
    modalCall: function(){
      this.showModal = true
    },
    selectNode(node_id){
      let selectedNode = this.nodes.find(currNode => {return currNode.node_id == node_id})
      this.selectedNodeId = selectedNode.node_id
    },
    CreateRootFolder(){
      this.folderCreationLoading = true
      this.Validate("new_folder_name")
      this.Validate("selected_node_id")
      if(!this.createError){
        FolderApi.createRootFolder(this.selectedNodeId, this.newFolderName).then(res=> {
          if(res.data.result){
            this.newFolderId = res.data.folder_id
            this.folders.push({
              "cp_id":this.newFolderId,
              "name": this.newFolderName
            })
            this.choosedExistingFolderId = this.newFolderId
            if(this.withChannel){
              this.CreateChannel()
            }
            this.folderCreationLoading = false
            Global.globalValue(VueSignals.SHOW_MODAL, false)
          }else if(res.data.reason == "folder_already_exists"){
            this.folderCreationLoading = false
            this.createError = true
            this.errorType = 'new_folder_name'
            this.errorMessage = "Folder already exists, choose a different name"
          }else if(res.data.reason == "user_has_no_access"){
            this.folderCreationLoading = false
            this.createError = true
            this.errorType = 'selected_node_id'
            this.errorMessage = "You do not have an access to the choosen node"
          }else if(res.data.reason == "user_has_no_access" || res.data.reason == "user_cannot_access_node"){
            this.folderCreationLoading = false
            this.createError = true
            this.errorType = 'selected_node_id'
            this.errorMessage = "You do not have an access to the choosen node"
          }else if(res.data.reason == "node_offline"){
            this.folderCreationLoading = false
            this.createError = true
            this.errorType = 'selected_node_id'
            this.errorMessage = "Choosen node is offline please choose an online one"
          }

        })
      }
    },
    Validate(type){
      if(type == 'new_folder_name'){
        if(this.newFolderName.length == 0){
          this.createError = true
          this.errorType = 'new_folder_name'
        }
        else if(!CPUtils.ValidateChannelName(this.newFolderName)){
          this.createError = true
          this.errorType = 'new_folder_name'
          this.errorMessage = "Username can't contain Special charachters like @  / \\ . $ or space "
        }else {
          this.createError = false
          this.errorMessage = ''
        }
      }
      if(type == 'selected_node_id'){
        if(this.selectedNodeId.length == 0){
          this.createError = true
          this.errorType = 'selected_node_id'
          this.errorMessage = 'Please select node to place the folder'
        }
      }
      this.folderCreationLoading = false
    },
    SwitchViewTo(view){
      this.activeView = view
    },
    HandleScroll (event){
      let container = event.target
      Logging.Debug(container)
      if(container.scrollHeight - container.clientHeight - container.scrollTop < 50 &&
        this.activeView == 'existingFolder'){
      if(container.classList.contains('subfolder-content')){
          this.ListSubFolders(this.listSubFolderOfFolderId)
      }else {
        if(!this.folderCreationLoading && !this.endOfContent){
          this.FolderApiCall(this.skip)
        }
      }


      }
    },
    FolderApiCall(skip){
      if(!this.endOfContent || subFolder){
        this.subFolder = false
        this.listSubFolderOfFolderId = ''
        this.skip += 20
        if(skip == 0){
          this.rootFolderContent = []
        }
        FolderApi.getRootfolderAllowedForChannelCreate(skip).then(res => {
          this.folderCreationLoading = true
          if(res.data.number > 0){
            // normalize
            for(let i=0;i<res.data.roots.length;i++){
                res.data.roots[i].type = 'folder'
                if(!SessionManager.getChannels().some(currChannel => currChannel.channel_id == res.data.roots[i].cp_id)){
                  if(!this.rootFolderContent.some(elm => {return elm.cp_id == res.data.roots[i].cp_id})){
                    res.data.roots[i].hasChannel = false
                    this.rootFolderContent.push(res.data.roots[i])
                  }
                }else {
                  res.data.roots[i].hasChannel = true
                  this.rootFolderContent.push(res.data.roots[i])
                }
            }
          }else {
            this.endOfContent = true
          }
          this.folderCreationLoading = false
        })
      }
    },
    CreateChannel(){
      if(this.choosedExistingFolderId.length == 0){
        this.createError = true
        this.errorType = "select_folder_id"
        this.errorMessage = "You have to choose folder"
        this.folderCreationLoading = false
        return
      }
      this.folderCreationLoading = true
      ChannelApi.createChannel(this.choosedExistingFolderId, '').then(
        res => {
          if(res.data.result){
            this.folderCreationLoading = false
            ChannelNotification.CreateChannel(new Channel(res.data.channel), SessionManager.getLoggedInUserId())
            let new_channel = SessionManager.createChannel(res.data.channel)
            SessionManager.setActiveChannel(new_channel)
            Global.globalValue(VueSignals.SHOW_MODAL, false)
          }else {
            if(res.data.reason == "channel_joined_not_created"){
              this.folderCreationLoading = false
              SessionManager.setActiveChannelById(this.choosedExistingFolderId)
              Global.globalValue(VueSignals.SHOW_MODAL, false)
            }
          }
        }
      )
    },
    SelectFolder(item){
      if(typeof item.hasChannel == 'undefined' || !item.hasChannel){
        this.choosedExistingFolderId = item.cp_id
      }else {
        this.createError = true
        this.errorType = "select_folder_id"
        this.errorMessage = "Selected has a channel"
        setTimeout(function(){
          Global.globalValue(VueSignals.CLEAR_CREATE_FOLDER_ERROR, true)
        }, 2000)
      }
    },
    ListSubFolders(folderId){
      this.folderCreationLoading = true
      this.subFolder = true
      if(this.listSubFolderOfFolderId == folderId){
        this.subFolderSkip += 20
      }

      this.listSubFolderOfFolderId = folderId

      FolderApi.listContent(this.listSubFolderOfFolderId, this.subFolderSkip).then(res=> {
        if(res.data.result){
          this.rootFolderContent = this.subFolderContent.concat(res.data.folder_content.filter(currItem => {return currItem.type == 'folder'}))
          this.parentId = res.data.parent_id
        }else {
          if(res.data.reason == 'node_is_offline'){
            this.errorMessage = 'Node is offline'
          }
          this.listSubFolderOfFolderId = ''
          this.subFolderSkip = 0
        }
        for(let i=0;i<this.rootFolderContent.length;i++){
          if(SessionManager.getChannels().some(currChannel => currChannel.channel_id == this.rootFolderContent[i].cp_id)){
            this.rootFolderContent[i].hasChannel = true
          }
        }
        this.folderCreationLoading = false
      })
    }
  }
}
